import styled from 'styled-components'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const BuyerEditFormStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */

  .main-content {
    min-height: calc(100vh - 267px);
  }

  .loading {
    justify-content: center;
    align-items: center;
  }

  .loader {
    border: 4px solid #3a39a8;
    border-radius: 50%;
    border-top: 4px solid #f3f3f3;
    width: 20px;
    height: 20px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
